﻿import { useState } from 'react';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
dayjs.extend(utc);

export default function useForm(initialFValues, validateOnChange = false, validate) {
  const [values, setValues] = useState(initialFValues);
  const [errors, setErrors] = useState({});

  const handleCheck = (e) => {
    setValues({ ...values, [e.target.name]: e.target.checked });
  };

  const handleIntChange = (e) => {
    setValues({ ...values, [e.target.name]: parseInt(e.target.value) });
  };

  const handleRTFChange = (id, v) => {
    setValues({ ...values, [id]: v });
  };

  const handleImageChange = (property, value) => {
    setValues({ ...values, [property]: value });
    if (validateOnChange) validate({ [property]: value });
  };

  const handleDataChange = (property, value) => {
    setValues({ ...values, [property]: value });
  };

  const handleDateChange = (e) => {
    setValues({ ...values, [e.target.name]: e.target.value });
  };

  const handleNoEventDateChange = (newVal, name) => {
    setValues({
      ...values,
      [name]: newVal || '',
    });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setValues({
      ...values,
      [e.target.name]: e.target.value,
    });
    if (validateOnChange) validate({ [name]: value });
  };

  const resetForm = () => {
    setValues(initialFValues);
    setErrors({});
  };

  const updateValues = (newFValues) => {
    setValues(newFValues);
  };

  return {
    values,
    setValues,
    errors,
    setErrors,
    handleInputChange,
    handleCheck,
    handleIntChange,
    handleRTFChange,
    handleImageChange,
    handleDateChange,
    handleNoEventDateChange,
    handleDataChange,
    resetForm,
    updateValues,
  };
}
